import * as React from 'react';

import styled from 'styled-components';

import { motion } from 'framer-motion';

import MotionOpacity from '@components/motion/motion-opacity';

export interface LinkIconProps {
  className?: string;
  onClick?: (ev: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}

export const LinkIcon: React.FC<LinkIconProps> = (props) => {
  const iconMotion = {
    rest: { rotate: 0, scale: 1 },
    hover: { rotate: 45, scale: 1.125 },
    tap: { rotate: 0, scale: 1.25 },
  };

  return (
    <MotionOpacity>
      <motion.svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        className={props.className}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        initial="rest"
        whileHover="hover"
        whileTap="tap"
        animate="rest"
        onClick={(ev) => (props.onClick ? props.onClick(ev) : null)}
      >
        <IconCircle cx="15" cy="15" r="15" />
        <IconPath
          variants={iconMotion}
          d="M14.8 17.5l-0.6 0.6c-0.7 0.6-1.6 0.6-2.3-0.1 -0.6-0.6-0.6-1.6-0.1-2.3l0.6-0.6c0.3-0.3 0.3-0.7 0-1 -0.3-0.3-0.7-0.3-1 0l-0.6 0.6c-1.2 1.2-1.2 3.1 0 4.3 1.2 1.2 3.1 1.2 4.3 0l0.6-0.6c0.3-0.3 0.3-0.7 0-1C15.5 17.2 15.1 17.2 14.8 17.5zM15.6 13.2l-2.3 2.3c-0.3 0.3-0.3 0.8 0 1.2s0.8 0.3 1.2 0l2.3-2.3c0.3-0.3 0.3-0.8 0-1.2S15.9 12.9 15.6 13.2zM19.1 10.9C18.5 10.3 17.8 10 17 10c-0.8 0-1.6 0.3-2.1 0.9l-0.6 0.6C14 11.7 14 11.9 14 12.2c0.1 0.2 0.2 0.4 0.5 0.5 0.2 0.1 0.5 0 0.7-0.2l0.6-0.6c0.7-0.6 1.6-0.6 2.3 0.1 0.6 0.6 0.6 1.6 0.1 2.3l-0.6 0.6c-0.3 0.3-0.3 0.7 0 1 0.3 0.3 0.7 0.3 1 0l0.6-0.6c0.6-0.6 0.9-1.3 0.9-2.1C20 12.2 19.7 11.5 19.1 10.9z"
        />
      </motion.svg>
    </MotionOpacity>
  );
};

export default styled(LinkIcon)`
  cursor: pointer;

  circle {
    transition: fill
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};

    &:hover {
      fill: ${({ theme }) => theme.colors.secondary};
    }
  }
`;

const IconPath = styled(motion.path)`
  fill: ${({ theme }) => theme.colors.primary};
`;

const IconCircle = styled.circle`
  fill: ${({ theme }) => theme.colors.box};
`;
